<template>
  <div class="finances-report">
    <div class="finances-report__header">
      <p>Defina el período y los criterios para generar su reporte</p>
    </div>

    <div class="finances-report__body">
      <!-- Fila 1 -->
      <div class="finances-report__grid">
        <!-- Fecha Inicio -->
        <div class="finances-report__date">
          <span class="finances-report__label">Fecha de inicio</span>
          <date-picker
            class="finances-report__field"
            type="date"
            value-type="format"
            :keys="{ value: 'id', label: 'name' }"
            @close="handleOpenChange"
            placeholder="Fecha Inicio"
            :input-attr="{ 'aria-label': 'Fecha de inicio' }"
            v-model="filtroFechaInicio"
          />
        </div>

        <!-- Fecha Término -->
        <div class="finances-report__date">
          <span class="finances-report__label">Fecha de término</span>
          <date-picker
            class="finances-report__field"
            type="date"
            value-type="format"
            format="YYYY-MM-DD"
            :keys="{ value: 'id', label: 'name' }"
            @close="handleOpenChange"
            placeholder="Fecha Término"
            :input-attr="{ 'aria-label': 'Fecha de término' }"
            v-model="filtroFechaTermino"
          />
        </div>
        <!-- Cliente -->
        <ui-select
          class="finances-report__field"
          has-search
          label="Cliente"
          :options="listaClientesUsuarioActual"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :keys="{ value: 'id', label: 'name' }"
          v-model="filtroCliente">
        </ui-select>

        <!-- Nave -->
        <ui-select
          class="finances-report__field"
          has-search
          label="Nave"
          :options="naves"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :keys="{ value: 'id', label: 'name' }"
          v-model="filtroNave">
        </ui-select>

        <!-- Naviera -->
        <ui-select
          class="finances-report__field"
          has-search
          label="Naviera"
          :options="navieras"
          placeholder="Seleccionar"
          :keys="{ value: 'id', label: 'name' }"
          v-model="filtroNaviera">
        </ui-select>

        <!-- POD -->
        <ui-select
          class="finances-report__field"
          has-search
          label="POD"
          :options="puertos"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :keys="{ value: 'id', label: 'name' }"
          v-model="filtroPod">
        </ui-select>

        <!-- Estado de facturación -->
        <ui-select
          class="finances-report__field"
          label="Facturación"
          :options="opcionesFacturacion"
          :keys="{ value: 'id', label: 'name' }"
          v-model="invoiceStatusFilter">
        </ui-select>
      </div>

      <!-- Footer -->
      <p class="finances-report__note">
        <i class="fa fa-envelope-o" aria-hidden="true"></i> El reporte se
        enviará a su correo electrónico
      </p>
      <div class="finances-report__footer">
        <button
          type="button"
          class="finances-report__button finances-report__button--secondary finances-report__button--clear"
          @click="clearFilters">
          <i class="fa fa-eraser" aria-hidden="true"></i> Limpiar filtros
        </button>
        <button
          type="button"
          class="finances-report__button finances-report__button--secondary"
          @click="handleSubmit(1)">
          <i class="fa fa-download" aria-hidden="true"></i> Generar reporte
          finanzas V1
        </button>
        <button
          type="button"
          class="finances-report__button finances-report__button--red"
          @click="handleSubmit(2)">
          <i class="fa fa-download" aria-hidden="true"></i> Generar reporte
          finanzas V2
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import UiSelect from "keen-ui/src/UiSelect";
import DatePicker from "vue2-datepicker";
import { generarReporteFinanzasLineas } from "@/constants/lineas";
import { mapState } from "vuex";
import VueToastify from "vue-toastify";
import "vue2-datepicker/locale/es";
import "vue2-datepicker/index.css";
import uuid from "keen-ui/src/helpers/uuid";

Vue.use(VueToastify);

const menuOptions = [
  {
    id: 'version-1',
    label: 'Versión 1',
    icon: 'v1',
    secondaryText: 'Ctrl+E'
  },
  {
    id: 'version-1',
    label: 'Versión 1',
    icon: 'fa fa-download'
  }
];

export default {
  data() {
    return {
      filtroFechaInicio: "",
      filtroFechaTermino: "",
      filtroCliente: "",
      filtroNave: "",
      filtroNaviera: "",
      filtroPod: "",
      invoiceStatusFilter: { id: null, name: "Todos" },
      opcionesFacturacion: [
        { id: null, name: "Todos" },
        { id: 1, name: "Facturado" },
        { id: 0, name: "Sin facturar" }
      ],
      //
      menuOptions
    };
  },
  components: {
    UiSelect,
    // UiTextbox,
    DatePicker
  },
  computed: {

    ...mapState(["navieras", "listaClientesUsuarioActual", "puertos", "naves"])
  },
  methods: {

    clearFilters() {
      this.filtroFechaInicio = "";
      this.filtroFechaTermino = "";
      this.filtroCliente = "";
      this.filtroNave = "";
      this.filtroNaviera = "";
      this.filtroPod = "";
      this.invoiceStatusFilter = this.opcionesFacturacion[0];
    },

    handleOpenChange() {
      this.showTimePanel = false;
    },

    async handleSubmit(version) {

      this.$vToastify.loader("Solicitando reporte...");

      const filters = {
        fechaInicio: this.filtroFechaInicio,
        fechaTermino: this.filtroFechaTermino,
        cliente: this.filtroCliente.id ?? null,
        nave: this.filtroNave.id ?? null,
        naviera: this.filtroNaviera.id ?? null,
        pod: this.filtroPod.id ?? null,
        isInvoiced: this.invoiceStatusFilter.id ?? null,
        useExtendedTariffs: version === 2
      };

      const { status, message } = await generarReporteFinanzasLineas(filters, uuid.short("reporte-finanzas-"));

      this.$vToastify.stopLoader();

      if (status === 200) {

        this.$vToastify.success("En unos minutos recibirá el reporte en su correo electrónico", message);

      } else {

        this.$vToastify.success("Intente nuevamente por favor", message);

      }

    }
  }
};
</script>

<style>
.finances-report {
  margin: 20px;
  color: #333333;
  background: #fff;
  border: 1px solid #dcdcdc;
  border-radius: 14px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);
}
.finances-report__header {
  padding: 28px 32px 24px;
  border-bottom: 1px solid #e5e5e5;
  background: #ffffff;
  border-radius: 14px 14px 0 0;
}
.finances-report__eyebrow {
  display: block;
  margin-bottom: 10px;
  color: #666666;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
}
.finances-report__header h2 {
  margin: 0 0 8px;
  color: #333333;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.025em;
}
.finances-report__header p {
  margin: 0;
  color: #666666;
  font-size: 14px;
}
.finances-report__grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 26px 24px;
  padding: 30px 32px;
}
.finances-report__date,
.finances-report .finances-report__field {
  min-width: 0;
  width: 100%;
  margin: 0;
}
.finances-report__label,
.finances-report .ui-select__label-text {
  display: block;
  margin: 0 0 8px;
  color: #555555;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
}
.finances-report .mx-input,
.finances-report .ui-select__display {
  height: 44px;
  min-height: 44px;
  padding: 0 12px;
  color: #333333;
  background: #fff;
  border: 1px solid #dcdcdc !important;
  border-radius: 7px !important;
  box-shadow: none !important;
  font-size: 14px;
  transition: border-color 0.18s, box-shadow 0.18s;
}
.finances-report .mx-input {
  padding-right: 34px;
}
.finances-report .ui-select__display-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.finances-report .ui-select__display-value.is-placeholder,
.finances-report .mx-input::placeholder {
  color: #777777;
}
.finances-report .mx-input:hover,
.finances-report .ui-select__label:hover .ui-select__display {
  border-color: #aaaaaa !important;
}
.finances-report .mx-input:focus,
.finances-report .ui-select__label:focus .ui-select__display,
.finances-report .ui-select.is-active .ui-select__display {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.12) !important;
  outline: none;
}
.finances-report__note {
  margin: 0;
  padding: 0 32px 24px;
  color: #666666;
  font-size: 12px;
}
.finances-report__note i {
  margin-right: 8px;
}
.finances-report__footer {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  padding: 22px 32px;
  border-top: 1px solid #e5e5e5;
  background: #fafafa;
  border-radius: 0 0 14px 14px;
}
.finances-report__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 44px;
  padding: 11px 18px;
  border: 1px solid transparent;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.18s, box-shadow 0.18s;
}
.finances-report__button--red {
  color: #fff;
  background: #dc3545;
  border-color: #dc3545;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
}
.finances-report__button--clear {
  margin-right: auto;
}
.finances-report__button--red:hover {
  background: #d32535;
}
.finances-report__button--secondary {
  color: #444;
  background: #f8f9fa;
  border-color: #ddd;
}
.finances-report__button--secondary:hover {
  background: #e7e5e5;
}
.finances-report__button:focus-visible {
  outline: 3px solid #dc3545;
  outline-offset: 3px;
}
@media (max-width: 1100px) {
  .finances-report__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 600px) {
  .finances-report {
    margin: 10px;
  }
  .finances-report__header,
  .finances-report__footer {
    padding: 22px 20px;
  }
  .finances-report__grid {
    grid-template-columns: minmax(0, 1fr);
    padding: 24px 20px;
    gap: 22px;
  }
  .finances-report__note {
    padding: 0 20px 24px;
  }
  .finances-report__button {
    width: 100%;
  }
}
</style>
